import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-4 mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card border-0 mb-0" }
const _hoisted_4 = { class: "card-body d-flex flex-wrap align-items-center justify-content-between gap-3" }
const _hoisted_5 = { class: "text-black fw-bold mb-1" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2 text-muted" }
const _hoisted_7 = { class: "col-lg-7" }
const _hoisted_8 = { class: "card border-0 h-100 mb-0" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-sm-6 col-md-4" }
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = { class: "col-sm-6 col-md-4" }
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = { class: "col-sm-6 col-md-4" }
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = { class: "col-sm-6 col-md-4" }
const _hoisted_18 = { class: "info-value" }
const _hoisted_19 = { class: "col-sm-6 col-md-4" }
const _hoisted_20 = { class: "info-value" }
const _hoisted_21 = {
  key: 0,
  class: "col-sm-6 col-md-4"
}
const _hoisted_22 = { class: "info-value" }
const _hoisted_23 = { class: "col-lg-5" }
const _hoisted_24 = { class: "card border-0 h-100 mb-0" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "row g-3" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "info-value" }
const _hoisted_29 = { class: "col-sm-6" }
const _hoisted_30 = { class: "info-value" }
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = { class: "info-value" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "info-value" }
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = { class: "card border-0 mb-0" }
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = { class: "table-responsive" }
const _hoisted_39 = { class: "table align-middle mb-0" }
const _hoisted_40 = { class: "fw-medium" }
const _hoisted_41 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = { class: "text-end" }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { class: "text-end fw-bold" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "col-lg-7" }
const _hoisted_51 = { class: "card border-0 h-100 mb-0" }
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3" }
const _hoisted_54 = { class: "row g-3" }
const _hoisted_55 = { class: "col-sm-6" }
const _hoisted_56 = { class: "info-value" }
const _hoisted_57 = { class: "col-sm-6" }
const _hoisted_58 = { class: "info-value" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = { class: "info-value text-break font-monospace" }
const _hoisted_61 = { class: "col-sm-4" }
const _hoisted_62 = { class: "info-value" }
const _hoisted_63 = { class: "col-sm-4" }
const _hoisted_64 = { class: "info-value" }
const _hoisted_65 = { class: "col-sm-4" }
const _hoisted_66 = { class: "info-value" }
const _hoisted_67 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_68 = { class: "fw-medium" }
const _hoisted_69 = { class: "text-muted" }
const _hoisted_70 = { class: "font-monospace small" }
const _hoisted_71 = { class: "col-lg-5" }
const _hoisted_72 = { class: "card border-0 h-100 mb-0" }
const _hoisted_73 = { class: "card-body" }
const _hoisted_74 = { class: "total-ligne" }
const _hoisted_75 = {
  key: 0,
  class: "total-ligne"
}
const _hoisted_76 = { class: "total-ligne" }
const _hoisted_77 = {
  key: 1,
  class: "total-ligne"
}
const _hoisted_78 = {
  key: 2,
  class: "total-ligne"
}
const _hoisted_79 = { class: "total-ligne total-ttc" }
const _hoisted_80 = { class: "total-ligne" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_5, "Vente " + _toDisplayString(_ctx.vente?.refCom || ''), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.format_Date(_ctx.vente?.dateCommande) || '-'), 1),
              (_ctx.statutPaiement)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["badge", _ctx.statutPaiement.classe])
                  }, _toDisplayString(_ctx.statutPaiement.libelle), 3))
                : _createCommentVNode("", true),
              (_ctx.vente)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["badge", _ctx.estNormalisee ? 'bg-success' : 'bg-secondary'])
                  }, _toDisplayString(_ctx.estNormalisee ? 'Normalisée' : 'Non normalisée'), 3))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_router_link, {
            to: "/ventes/liste-ventes",
            class: "btn btn-primary transition border-0 lh-1 fw-medium"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
              _createTextVNode(" Retour ")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "fw-bold mb-3" }, "Informations de la vente", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "info-label" }, "Référence", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.vente?.refCom || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "info-label" }, "Date", -1)),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.format_Date(_ctx.vente?.dateCommande) || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info-label" }, "Type de commande", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.vente?.typeCommande || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info-label" }, "Type de facture", -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.vente?.typeFacture || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-label" }, "Taux AIB", -1)),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.vente?.tauxAib ? `${_ctx.vente.tauxAib} %` : 'Aucun'), 1)
            ]),
            (_ctx.vente?.dateLivPrev)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info-label" }, "Livraison prévue", -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.format_Date(_ctx.vente?.dateLivPrev)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "fw-bold mb-3" }, "Client", -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "info-label" }, "Nom", -1)),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.nomClient), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "info-label" }, "IFU", -1)),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.vente?.client?.ifu || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "info-label" }, "Téléphone", -1)),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.vente?.client?.telephone1 || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "info-label" }, "Adresse", -1)),
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.vente?.client?.adresseClient || '-'), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "fw-bold mb-3" }, "Produits vendus", -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("table", _hoisted_39, [
              _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Produit"),
                  _createElementVNode("th", { class: "text-end" }, "Qté"),
                  _createElementVNode("th", { class: "text-end" }, "Prix unit. TTC"),
                  _createElementVNode("th", { class: "text-end" }, "Remise"),
                  _createElementVNode("th", { class: "text-end" }, "Montant HT"),
                  _createElementVNode("th", { class: "text-end" }, "TVA"),
                  _createElementVNode("th", { class: "text-end" }, "Taxe spéc."),
                  _createElementVNode("th", { class: "text-end" }, "Montant TTC")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lignes, (produit, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(produit?.libelleProduit || produit?.produitConditionnement?.nomProCond || '-'), 1),
                      (produit?.groupeTaxe)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_41, "Groupe de taxe " + _toDisplayString(produit.groupeTaxe), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.nombre(produit?.qtite)), 1),
                    _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.montant(produit?.prixTtc)), 1),
                    _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.remiseLigne(produit)), 1),
                    _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.montant(_ctx.htLigne(produit))), 1),
                    _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.montant(produit?.montantTva)), 1),
                    _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.montant(produit?.montantTs)), 1),
                    _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.montant(produit?.montantTtc)), 1)
                  ]))
                }), 128)),
                (_ctx.vente && !_ctx.lignes.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_49, _cache[13] || (_cache[13] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        class: "text-center text-muted py-4"
                      }, "Aucun produit pour cette vente.", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "fw-bold mb-0" }, "Normalisation MECeF", -1)),
            (_ctx.vente)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["badge", _ctx.estNormalisee ? 'bg-success' : 'bg-secondary'])
                }, _toDisplayString(_ctx.estNormalisee ? 'Normalisée' : 'Non normalisée'), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "info-label" }, "Facture", -1)),
              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.facture?.refFac || 'Pas encore générée'), 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "info-label" }, "Date facture", -1)),
              _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.format_Date(_ctx.facture?.dateFac) || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "info-label" }, "Code MECeF/DGI", -1)),
              _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.facture?.mecefCode || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "info-label" }, "Compteurs", -1)),
              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.facture?.mecefCompteur || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "info-label" }, "NIM", -1)),
              _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.facture?.mecefNim || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "info-label" }, "Normalisée le", -1)),
              _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.format_Date(_ctx.facture?.mecef_date) || '-'), 1)
            ])
          ]),
          (_ctx.autresFactures.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "info-label mb-2" }, "Autres factures liées", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autresFactures, (f) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: f.id,
                    class: "d-flex flex-wrap justify-content-between gap-2 py-1"
                  }, [
                    _createElementVNode("span", _hoisted_68, [
                      _createTextVNode(_toDisplayString(f.refFac || '-') + " ", 1),
                      _createElementVNode("small", _hoisted_69, _toDisplayString(f.typeFacture || ''), 1)
                    ]),
                    _createElementVNode("span", _hoisted_70, _toDisplayString(f.mecefCode || 'Non normalisée'), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("div", _hoisted_73, [
          _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "fw-bold mb-3" }, "Récapitulatif", -1)),
          _createElementVNode("div", _hoisted_74, [
            _cache[24] || (_cache[24] = _createElementVNode("span", null, "Total HT", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.totaux.ht)), 1)
          ]),
          (_ctx.totaux.remise > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _cache[25] || (_cache[25] = _createElementVNode("span", null, "Remise", -1)),
                _createElementVNode("span", null, "- " + _toDisplayString(_ctx.montant(_ctx.totaux.remise)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_76, [
            _cache[26] || (_cache[26] = _createElementVNode("span", null, "TVA", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.totaux.tva)), 1)
          ]),
          (_ctx.totaux.ts > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _cache[27] || (_cache[27] = _createElementVNode("span", null, "Taxe spécifique", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.totaux.ts)), 1)
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.vente?.montantAib) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _createElementVNode("span", null, "AIB (" + _toDisplayString(_ctx.vente?.tauxAib) + " %)", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.vente?.montantAib)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_79, [
            _cache[28] || (_cache[28] = _createElementVNode("span", null, "Total TTC", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.totaux.ttc)), 1)
          ]),
          _createElementVNode("div", _hoisted_80, [
            _cache[29] || (_cache[29] = _createElementVNode("span", null, "Montant reçu", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.vente?.montantReçu)), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["total-ligne", Number(_ctx.vente?.montantRest) > 0 ? 'text-danger fw-bold' : ''])
          }, [
            _cache[30] || (_cache[30] = _createElementVNode("span", null, "Reste à payer", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.montant(_ctx.vente?.montantRest)), 1)
          ], 2)
        ])
      ])
    ])
  ]))
}